const validUrl = url => {
    const pattern = new RegExp(/^((https):\/\/).*([a-z0-9]+)\.([a-z]{2,4})/);
    return !!url.match(pattern);
};

const validationHandler = (id, inputUrl, inputName, inputSystems) => {
    const response = { valid: false, url: '', name: '' };
    const newSystemArray = inputSystems.reduce((acc, value) => {
        if (value.id === id) return acc;
        acc.push(value);
        return acc;
    }, []);
    const isNameExists = newSystemArray.find(s => s.friendlyName === inputName);
    const isServerUrlExists = newSystemArray.find(s => s.sealUrl === inputUrl);
    const isHttpsServer = inputUrl.toLowerCase().startsWith('https://');
    const isServerNameLong = inputName.length > 60;
    const isUrlValid = validUrl(inputUrl);

    if (inputUrl.length === 0) {
        response.url = 'Seal server url is missing';
        if (inputName.length === 0) response.name = 'Seal server name is missing';
        return response;
    }

    if (inputName.length === 0) {
        response.name = 'Seal system name is missing';
    }

    if (!isUrlValid) {
        response.url = 'Please enter a valid url';
    }

    if (isNameExists) {
        response.name = 'Seal server name is already used';
    }

    if (isServerUrlExists) {
        response.url = 'Seal server url is already used';
    }

    if (isServerNameLong) {
        response.name = 'Seal server name must not exceed 60 characters';
    }

    if (!isHttpsServer) {
        response.url = 'Seal server url must start with https://';
    }

    if (response.url === '' && response.name === '') {
        response.valid = true;
    }

    return response;
};

export default validationHandler;
